var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leco-page-wrapper",attrs:{"id":"leco-app"}},[_c('LecoHeader'),_c('router-view'),_c('LecoFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }